import { Component, OnInit } from '@angular/core';
import { TabItem } from '../../../common/models/common.model';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractTabComponent } from '../../../common/abstracts/abstract-tab.component';

@Component({
  selector: 'app-orders-overview',
  standalone: false,
  templateUrl: './orders-overview.component.html',
  styleUrl: './orders-overview.component.scss',
})
export class OrdersOverviewComponent extends AbstractTabComponent implements OnInit {
  constructor(
    protected override route: ActivatedRoute,
    protected override router: Router
  ) {
    super(route, router);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  selectedTab = 'orders';
  tabs: TabItem[] = [
    { label: 'Orders', icon: 'bi-shop', value: 'orders', permissionCode: 'ui_orders.orders.view' },
    {
      label: 'Dispatched Orders',
      icon: 'bi-truck',
      value: 'dispatched-orders',
      permissionCode: 'ui_orders.dispatched.view',
    },
    {
      label: 'Pending Orders',
      icon: 'bi-hourglass-split',
      value: 'pending-orders',
      permissionCode: 'ui_orders.pending.view',
    },
    {
      label: 'Transporters',
      icon: 'bi-person-badge',
      value: 'transporters',
      permissionCode: 'ui_orders.transporters.view',
    },
  ];
}
